// DealMainInfos version 0.1.1
import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Box, Tooltip, Typography } from "@mui/material";

import RealEstateCarousel from "../RealEstate/RealEstateCarousel";
import CircularProgressWithLabel from "../Common/CircularProgressWithLabel";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";

import HomeIcon from "@mui/icons-material/Home";

import palette from "../../theme/palette";
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CardTemplate from "../Common/CardTemplate";

export default function DealMainInfos({ state, uid, mode }) {
	const [showMore, setShowMore] = useState(false);
	var m = state.actualDeal.assets.filter((rlest) => rlest.mn)[0];
	if (m === undefined) {
		m = { ln: "", lt: "" };
	}
	var other_assets = state.actualDeal.assets.filter((rlest) => !rlest.mn);
	var gg = state.actualDeal.assets.reduce((acc, ass) => { return acc + ass.fld_nok }, 0)
	//console.log("all fld_nok", gg);
	return (
		<CardTemplate
			title="Description"
			buttons={((mode == "A" && !state.actualDeal.mandate) || (mode == "V" && state.actualDeal.idp)) &&
				<ButtonWithTooltipAndBadge
					tooltip="Gérer les biens"
					icon={<HomeIcon />}
					onclick_cb={() => {
						//		console.log(state.actualDeal.assets, state.actualDeal.assets[0])
						window.location.href = (state.actualDeal.assets.length == 1 ? "/dre0/" + state.actualDeal.assets[0].uid + "/1" : "/dre/" + uid) + "?from=" + window.location.href;
					}}
					badge={gg > 0} />
			}
			content={
				<Fragment >
					<Box display="flex" alignItems="center" justifyContent="space-between" >
						<Box  >
							<Typography variant="h5">{m ? m.tp : <em>Pas de type enregistré</em>}</Typography>
							<Typography variant="body1">{m ? m.a : <em>Pas d'adresse enregistrée</em>}</Typography>
						</Box>
						<Box display="flex" justifyContent="flex-end" alignItems="center">
							<Box p={1}>
								{m.fld_nok > 0 &&
									<CircularProgressWithLabel value={100 * m.fld_ok / (m.fld_ok + m.fld_nok)} />
								}
								{m.fld_nok === 0 && (
									<Tooltip title="Descriptif bien complet">
										<CheckCircleIcon
											style={{
												color: palette.success.main,
											}}
										/>
									</Tooltip>
								)}
							</Box>
							<Box p={1}>
								<Tooltip title={m.docs ? "Documents complets" : "Documents incomplets (à compléter par le vendeur)"}>
									<TaskIcon
										style={{
											color: m.docs ? palette.success.main : palette.warning.main,
										}}
									/>
								</Tooltip>
							</Box>
						</Box>
					</Box>
					<style>{`
						.deal-main-infos-toggle,
						.deal-main-infos-toggle:link,
						.deal-main-infos-toggle:visited,
						.deal-main-infos-toggle:hover,
						.deal-main-infos-toggle:focus,
						.deal-main-infos-toggle:active {
							color: #6B7280 !important;
							text-decoration: none !important;
							background: transparent !important;
							box-shadow: none !important;
						}
					`}</style>
					<Box mt={1} mb={2}>
						<a
							href="#"
							className="deal-main-infos-toggle"
							onClick={(event) => {
								event.preventDefault();
								setShowMore((visible) => !visible);
							}}
						>
							{showMore ? "réduire ▴" : "voir plus ▾"}
						</a>
					</Box>
					{showMore && (
						<Fragment>
							<Typography variant="body1" style="white-space: pre-wrap;line-height: normal;">
								{state.actualDeal.descr === null ? <em>Pas encore de description</em> : `${state.actualDeal.descr}`}
							</Typography>
							{other_assets.length > 0 && other_assets.map((asst) => {
								return <Box display="flex" alignItems="center" justifyContent="space-between">
									<Box  >
										<Typography variant="h5">{asst.tp ? asst.tp : <em>Pas de type enregistré</em>}</Typography>
										<Typography variant="body1">{asst.a ? asst.a : <em>Pas d'adresse enregistrée</em>}</Typography>
									</Box>
									<Box display="flex" justifyContent="flex-end" alignItems="center">
										<Box p={1}>
											{asst.fld_nok > 0 &&
												<CircularProgressWithLabel value={100 * asst.fld_ok / (asst.fld_ok + asst.fld_nok)} />
											}
											{asst.fld_nok === 0 && (
												<Tooltip title="Descriptif bien complet">
													<CheckCircleIcon
														style={{
															color: palette.success.main,
														}}
													/>
												</Tooltip>
											)}

										</Box>
										<Box p={1}>
											<Tooltip title="Documents complets">
												<TaskIcon
													style={{
														color: asst.docs ? palette.success.main : palette.warning.main,
													}}
												/>
											</Tooltip>
										</Box>
									</Box>
								</Box>
							})}
							<div style="margin-top: 10px">
								{state.actualDeal.pics === undefined && (
									<Typography variant="body1" style="margin-top: 20px; margin-bottom: 20px;">
										Aucune photo disponible
									</Typography>
								)}
								{state.actualDeal.pics && state.actualDeal.pics.length == 0 && (
									<Typography variant="body1" style="margin-top: 20px; margin-bottom: 20px;">
										Aucune photo disponible
									</Typography>
								)}
								{state.actualDeal.pics && state.actualDeal.pics.length > 0 && (
									<RealEstateCarousel pics={state.actualDeal.pics} deal_uid={uid} mode="RO" dim="200" />
								)}
							</div>
						</Fragment>
					)}
				</Fragment >
			}
		/>)

}
